import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WhenAuthenticatedGuard } from './services/guards/when-authenticated.guard';
import { WhenNotAuthenticatedGuard } from './services/guards/when-not-authenticated.guard';
import { ApplicationLayoutComponent } from './core/layouts/application-layout/application-layout.component';
import { LayoutsModule } from './core/layouts/layouts.module';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    canActivate: [WhenNotAuthenticatedGuard],
    loadChildren: () => import('./states/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'project/:accountId',
    canActivate: [WhenAuthenticatedGuard],
    component: ApplicationLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'menu',
        pathMatch: 'full',
      },
      {
        path: 'menu',
        loadChildren: () => import('./states/menu/menu.module').then(m => m.MenuModule),
      },
      {
        path: 'deviceadd',
        loadChildren: () => import('./states/device-add/device-add.module').then(m => m.DeviceAddModule),
      },
      {
        path: 'licenseadd',
        loadChildren: () => import('./states/license-add/license-add.module').then(m => m.LicenseAddModule),
      },
    ],
  },
  {
    path: 'accounts',
    canActivate: [WhenAuthenticatedGuard],
    component: ApplicationLayoutComponent,
    loadChildren: () => import('./states/accounts/accounts.module').then(m => m.AccountsModule),
  },
  // Fallback when no prior routes is matched
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    LayoutsModule,
    RouterModule.forRoot(routes, {}),
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule {
}
